import { render, staticRenderFns } from "./top-products.vue?vue&type=template&id=4b9bacda&"
import script from "./top-products.vue?vue&type=script&lang=ts&"
export * from "./top-products.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports